import { Application } from '@frontend/functionality/types';
import React from 'react';
import { LuBuilding2 } from 'react-icons/lu';

import AddressBook from './svg/address-book';
import Analytics from './svg/analytics';
import Catalogue from './svg/catalogue';
import Fingerprint from './svg/fingerprint';
import Hardware from './svg/hardware';
import Itsme from './svg/itsme';
import Laundry from './svg/laundry';
import Lending from './svg/lending';
import My from './svg/my';
import Nivaliz from './svg/nivaliz';
import NoItems from './svg/no-items';
import NoLaundry from './svg/no-laundry';
import Pudo from './svg/pudo';
import ShoppingBasket from './svg/shopping-basket';
import Spots from './svg/spots';
import Users from './svg/users';
import Utilities from './svg/utilities';
import Vending from './svg/vending';

const Organization = (props: { className?: string }) => <LuBuilding2 className={props.className} />;

// Do we really need all applications to have an icon? Because not all application's their icon are being shown in the new navbar design

export const APPLICATION: { [application in Application | 'my']: (props: { className?: string }) => React.JSX.Element } = {
    my: My,
    address_book: AddressBook,
    admin: Utilities,
    analytics: Analytics,
    authentication: Fingerprint,
    authorization: Utilities,
    budgets: My,
    catalogue: Catalogue,
    hardware: Hardware,
    itsme: Itsme,
    laundry: Laundry,
    monitoring: My,
    notifications: My,
    nivaliz: Nivaliz,
    organization: Organization,
    pudo: Pudo,
    spots: Spots,
    shop: ShoppingBasket,
    users: Users,
    vending: Vending,
    lending: Lending,
    constraints: My,
    requirements: My
};

export const LICENSE_EXCEPTIONS = {
    MY: {
        /** Laundry empty-state illustration — use only in laundry corporate/personal flows. */
        NO_TRANSACTIONS: NoLaundry,
        /** Generic empty-state illustration for non-laundry lists. */
        NO_ITEMS: NoItems
    }
};
